import type {LightAnimation} from "@/dungeons/model/DungeonGeometry.ts";

function seedOf(id: string) {
    let seed = 2166136261;
    for (const char of id) seed = Math.imul(seed ^ char.charCodeAt(0), 16777619);
    return seed >>> 0;
}

function noise(index: number, seed: number) {
    let value = Math.imul(index ^ seed, 0x45d9f3b);
    value = Math.imul(value ^ (value >>> 16), 0x45d9f3b);
    return ((value ^ (value >>> 16)) >>> 0) / 4294967295;
}

function smoothNoise(time: number, seed: number) {
    const index = Math.floor(time);
    const fraction = time - index;
    const weight = fraction * fraction * (3 - 2 * fraction);
    return noise(index, seed) * (1 - weight) + noise(index + 1, seed) * weight;
}

/** Stateless, continuous and deterministic across views; only attenuates the configured light. */
export function lightAnimationFactor(animation: LightAnimation | null | undefined, id: string, seconds: number) {
    if (!animation || animation.strength === 0) return 1;
    const seed = seedOf(id);
    const time = seconds * animation.speed;
    const phase = seed / 4294967295 * Math.PI * 2;
    const signal = animation.effect === "PULSE" ? (1 + Math.sin(time * Math.PI + phase)) / 2
        : 0.65 * smoothNoise(time * 3, seed) + 0.35 * smoothNoise(time * 7, seed ^ 0x9e3779b9);
    return 1 - animation.strength * signal;
}
